/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-02-06 14:06:02
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\user.js
 */
import { post, get } from '../axios'
const user = {
  // 新增用户
  addUser: (params) => post('/web/user/addUser', params),
  // 用户登录
  edcLogin: (params) => post('/web/user/edcLogin', params),
  // 修改用户
  editUser: (params) => post('/web/user/editUser', params),
  // 重置密码
  forgetPwd: (params) => post('/web/user/forgetPwd', params),
  // 获取登录验证码
  getLoginCode: (params) =>
    get('/web/verification/getVerificationCode', params),
  // 获取用户角色
  getRoleByType: (params) => post('/web/user/getRoleByType', params),
  // 获取用户信息
  getUserInfoByName: (params) => post('/web/user/getUserInfoByName', params),
  // 修改密码
  updatePassword: (params) => post('/web/user/modifyPassword', params),
  // 获取项目角色
  getEntryRoleSelectList: (parmas) =>
    get('/web/role/getEntryRoleSelectList', parmas),
  // 获取研究用户列表
  getResearchUserList: (parmas) =>
    get(`/web/researchUser/getParticipationUserList/${parmas}`),
  // 获取未参与研究的用户下拉列表
  getUnParticipationUserSelectList: (parmas) =>
    get(`/web/researchUser/getUnParticipationUserSelectList/${parmas}`),
  // 获取研究用户详情
  getResearchUserDetial: (parmas) =>
    get(`/web/researchUser/getResearchUser/${parmas}`),
  // 分配研究
  participateResearch: (parmas) =>
    post('/web/researchParticipation/participateResearch', parmas),
  // 添加研究下用户
  addResearchUser: (parmas) =>
    post('/web/researchUser/saveResearchUser', parmas),
  // 编辑研究下用户
  editResearchUser: (parmas) =>
    post('/web/researchUser/updateResearchUser', parmas),
  // 用户登录后关联openID
  saveUserOpenId: (params) => post('/web/userWechat/saveUserWechat', params),
  // 通过openID查询用户（医生）信息
  getUserInfoByOpenID: (openId) => get(`/web/userWechat/getUser/${openId}`),
  // 查询用户基本信息
  getUserBase: (params) => get(`/web/subject/getSubject`, params),
  // 判断用户是否为录入员
  getUserRole: (params) => get(`/web/user/getUserRole`, params),
  // 录入员-患者入组统计
  selectSubjectFormCount: (params) =>
    get(`/web/subject/selectSubjectFormCount`, params),
  // 患者入组统计
  selectSubjectCount: (params) =>
    get(`/web/subject/selectSubjectCount`, params)
}
export default user
